import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Cuidado } from '../models/salud-cuidado.model';

@Injectable({
  providedIn: 'root'
})
export class SaludService {
  private cuidadoSubject = new BehaviorSubject<Cuidado | null>(null);
  cuidado$ = this.cuidadoSubject.asObservable();

  constructor() { }

  setCuidado(cuidado: Cuidado | null) {
    this.cuidadoSubject.next(cuidado);
  }
  getCuidado(): Cuidado | null {
    return this.cuidadoSubject.value;
  }

}
